// extracted by mini-css-extract-plugin
module.exports = {"square":"dmbc-base_square-square","placeholder":"dmbc-base_square-placeholder"};